import { Outlet, useLocation, useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { ADMIN_ROLE_LABELS } from "@/lib/roles";

const TABS = [
  { path: "/admin-users", label: "账号管理" },
  { path: "/system-config", label: "系统配置(JSON)" },
];

export default function AdminUsersLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { admin, logout } = useAdminAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col">
      <header className="h-[64px] bg-white border-b border-surface-border flex items-center justify-between px-4 md:px-8 shrink-0">
        <div className="flex items-center gap-3 min-w-0">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-text-secondary hover:bg-surface hover:text-text-primary transition-colors text-sm cursor-pointer shrink-0"
          >
            <i className="ri-arrow-left-line text-base" />
            <span>返回首页</span>
          </button>

          <div className="w-px h-5 bg-surface-border hidden sm:block" />

          <div className="flex items-center gap-2.5 min-w-0">
            <div className="w-8 h-8 rounded-lg bg-brand/10 flex items-center justify-center shrink-0">
              <i className="ri-admin-line text-brand text-base" />
            </div>
            <div className="min-w-0 flex items-center gap-2">
              <span className="text-text-primary font-semibold text-sm">系统管理</span>
              <span className="text-text-muted text-xs hidden sm:inline">· 超级管理员专属</span>
            </div>
          </div>

          <nav className="ml-3 hidden md:flex items-center gap-1">
            {TABS.map((tab) => {
              const active =
                location.pathname === tab.path ||
                location.pathname.startsWith(`${tab.path}/`);
              return (
                <Link
                  key={tab.path}
                  to={tab.path}
                  className={`px-3 py-1.5 rounded-lg text-sm transition-colors whitespace-nowrap ${
                    active
                      ? "bg-brand/10 text-brand font-medium"
                      : "text-text-secondary hover:bg-surface hover:text-text-primary"
                  }`}
                >
                  {tab.label}
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="flex items-center gap-3 md:gap-4 shrink-0">
          <button
            onClick={() => navigate("/")}
            className="hidden sm:flex items-center gap-2 rounded-lg px-1 py-1 hover:bg-surface transition-colors cursor-pointer"
          >
            <div className="w-7 h-7 rounded-lg bg-brand flex items-center justify-center">
              <i className="ri-bar-chart-grouped-line text-white text-sm" />
            </div>
            <span className="text-text-secondary text-sm">钜睿科技</span>
          </button>

          <div className="relative">
            <button
              onClick={() => setShowUserMenu((s) => !s)}
              className="flex items-center gap-2 px-2 py-1.5 rounded-xl hover:bg-surface transition-colors cursor-pointer"
            >
              <div className="w-7 h-7 rounded-full bg-brand/10 flex items-center justify-center">
                <i className="ri-user-line text-brand text-xs" />
              </div>
              <span className="text-text-secondary text-sm hidden sm:block max-w-[140px] truncate">
                {admin?.email || "管理员"}
              </span>
              <i className={`ri-arrow-down-s-line text-text-muted text-xs transition-transform hidden sm:block ${showUserMenu ? "rotate-180" : ""}`} />
            </button>

            {showUserMenu && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setShowUserMenu(false)} />
                <div className="absolute right-0 top-full mt-2 w-[200px] bg-white rounded-2xl border border-surface-border py-2 z-50">
                  <div className="px-4 py-3 border-b border-surface-border">
                    <p className="text-text-primary text-sm font-medium truncate">
                      {admin?.email || "管理员"}
                    </p>
                    <p className="text-text-muted text-xs mt-0.5">
                      {admin?.role ? ADMIN_ROLE_LABELS[admin.role] ?? admin.role : ""}
                    </p>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-3 px-4 py-3 text-sm text-status-danger hover:bg-red-50 transition-colors cursor-pointer"
                  >
                    <i className="ri-logout-box-r-line text-base" />
                    <span>退出登录</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-4 md:p-6 lg:p-8">
        <Outlet />
      </main>
    </div>
  );
}
